import { type ReactNode, useCallback, useRef, useState } from 'react';
import { CollapsibleGroupContext } from './collapsible-group.context';

interface CollapsibleGroupProps {
  children: ReactNode;
  defaultExpanded?: string | null;
}

export const CollapsibleGroup = ({ children, defaultExpanded = null }: CollapsibleGroupProps) => {
  const [expandedId, setExpandedId] = useState<string | null>(defaultExpanded);
  const lockedIdsRef = useRef(new Set<string>());

  const setExpandedLocked = useCallback((id: string, locked: boolean) => {
    if (locked) {
      lockedIdsRef.current.add(id);
      setExpandedId(id);
      return;
    }

    lockedIdsRef.current.delete(id);
  }, []);

  const toggleExpanded = useCallback((id: string) => {
    setExpandedId((prevId) => {
      if (prevId === id) {
        if (lockedIdsRef.current.has(id)) {
          return prevId;
        }
        return null;
      }
      return id;
    });
  }, []);

  return (
    <CollapsibleGroupContext.Provider value={{ expandedId, toggleExpanded, setExpandedId, setExpandedLocked }}>
      {children}
    </CollapsibleGroupContext.Provider>
  );
};
